module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    class: ['theme-' + _vm.selectedTheme, {
      'rolled-out': _vm.isRolledOut
    }],
    attrs: {
      "id": "chat-side-panel"
    }
  }, [_c('div', [_c('div', {
    attrs: {
      "id": "logo-container"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars toggle-side-panel",
    on: {
      "click": function($event) {
        return _vm.toggleRollOut()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('logged-details')], 1), _vm._v(" "), _c('div', [_c('online-users')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa4247e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chatroom/ChatSidePanel.vue
// module id = 386
// module chunks = 1